import React, { useEffect, useState } from "react"
import "./photo.css"

const TRANSITION = 500

export default function Photo({ photos }) {
  const [idPhoto, setIdPhoto] = useState(0)
  const [cn, setCn] = useState("photo-enter photo-enter-active")

  useEffect(() => {
    const intervalPhoto = setInterval(() => {
      let ip = idPhoto + 1
      if (ip >= photos.length) ip = 0
      setTimeout(() => {
        setCn("photo-exit photo-exit-active")
        setTimeout(() => {
          setCn("photo-enter photo-enter-active")
          setIdPhoto(ip)
        }, TRANSITION)
      }, TRANSITION)
    }, 1500 + 2 * TRANSITION)
    return () => {
      clearInterval(intervalPhoto)
    }
  })

  return (
    <img
      src={photos[idPhoto].photoImage.asset.fixed.src}
      className={cn}
      alt=""
    />
  )
}
